if (!customElements.get('benefits-compare')) {
  customElements.define('benefits-compare', class BenefitsCompare extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }
      onClick(event) {
        const tabButton = event.target.closest('.tab-item');
        if (!tabButton || !this.contains(tabButton)) return;

        const target = tabButton.getAttribute('target');
        if (!target) return;

        const box = tabButton.closest('.item-box');
        if (!box) return;

        const tabs = Array.from(box.querySelectorAll('.item-tab .tab-item'));
        tabs.forEach((tab) => tab.classList.remove('active'));
        tabButton.classList.add('active');

        const contents = Array.from(box.querySelectorAll('.item-content .tab-item-content'));
        contents.forEach((content) => {
          content.classList.toggle('active', content.getAttribute('target') === target);
        });
      }
    }
  );
}
